export default __webpack_public_path__ + "static/media/Group8886.1408615f.svg";